"use strict";

(function (Drupal) {
  Drupal.behaviors.hero_carousel = {
    attach: function attach(context, settings) {
      var carousel = context.querySelector('.home-hero-carousel');
      var body = document.body;
      if (!carousel || body.classList.contains('layout-builder--is-enabled')) {
        return;
      }
      var slides = carousel.querySelectorAll('.carousel--item');
      var slideCount = slides.length;
      var cursor = carousel.querySelector('.cursor');
      var progressBar = carousel.querySelector('.progress-bar');
      var progressTimeline = gsap.timeline({
        repeat: -1
      });
      var pager = carousel.querySelector('.carousel--pager');
      var classes = {
        active: 'js-slide-is-active',
        changing: 'js-slide-is-changing',
        hovering: 'js-cursor-is-hovering',
        lb: 'layout-builder--is-disabled',
        left: 'js-cursor-is-left',
        next: 'js-slide-is-next',
        processed: 'js-is-processed',
        right: 'js-cursor-is-right'
      };

      /**
       * Establish the slide order and what slide is next.
       * @param {string} direction The direction the cursor is pointing.
       */
      var slideOrder = function slideOrder(direction) {
        var activeSlide = carousel.querySelector(".".concat(classes.active));
        var nextSlide = carousel.querySelector(".".concat(classes.next));

        // When this function runs, we need to reset the next slide becuase we set it below.
        if (nextSlide) {
          nextSlide.classList.remove(classes.next);
        }

        // The first time we run we set the second slide as the next slide and the right direction.
        // Otherwise weird stuff happens if we don't move the cursor.
        if (!carousel.classList.contains(classes.processed)) {
          carousel.querySelector('[data-index="2"]').classList.add(classes.next);
          carousel.classList.add(classes.right);
          carousel.classList.add(classes.processed);
        }
        switch (direction) {
          case 'right':
            // If we are pointing right, we switch the carousel wrapper class
            // to indicate that we are pointing right.
            if (carousel.classList.contains(classes.left)) {
              carousel.classList.remove(classes.left);
            }
            if (!carousel.classList.contains(classes.right)) {
              carousel.classList.add(classes.right);
            }
            // If there's a slide after the active slide, we add the next class to it.
            if (activeSlide.nextElementSibling !== null && activeSlide.nextElementSibling.getAttribute('data-index') <= slideCount) {
              activeSlide.nextElementSibling.classList.add(classes.next);
            } else {
              // Otherwise, the first slide is the next slide and we've rotated all the way through.
              carousel.querySelector('[data-index="1"]').classList.add(classes.next);
            }
            break;
          case 'left':
            // If we are pointing left, we switch the carousel wrapper class
            // to indicate that we are pointing left.
            if (carousel.classList.contains(classes.right)) {
              carousel.classList.remove(classes.right);
            }
            if (!carousel.classList.contains(classes.left)) {
              carousel.classList.add(classes.left);
            }
            // If there's a slide before the active slide, we add the next class to it.
            if (activeSlide.previousElementSibling !== null && activeSlide.previousElementSibling.getAttribute('data-index') >= 1) {
              activeSlide.previousElementSibling.classList.add(classes.next);
            } else {
              // Otherwise it's whatever the last slide is, so equal to the total slide count.
              carousel.querySelector("[data-index=\"".concat(slideCount, "\"]")).classList.add(classes.next);
            }
            break;
        }
      };

      /* Handle the slide transition. */
      var slideTransition = function slideTransition(direction, fromPager) {
        // We need to reset the slide order to progress forward if this is fired from
        // the pager animation function. Otherwise it looks backwards.
        if (fromPager == true) {
          Drupal.behaviors.dart_utils.incrementPager(pager, slideCount);
          slideOrder('right');
        } else if (direction == 'left') {
          Drupal.behaviors.dart_utils.incrementPager(pager, slideCount, true);
        } else if (direction == 'right') {
          Drupal.behaviors.dart_utils.incrementPager(pager, slideCount);
        }
        var activeSlide = carousel.querySelector(".".concat(classes.active));
        var nextSlide = carousel.querySelector(".".concat(classes.next));
        activeSlide.classList.add(classes.changing);
        nextSlide.style.display = 'block';

        // Since the sliding animation is a second long, we delay our class swapping.
        setTimeout(function () {
          activeSlide.classList.remove(classes.changing);
          activeSlide.classList.remove(classes.active);
          nextSlide.classList.add(classes.active);
          nextSlide.classList.remove(classes.next);
          carousel.classList.remove(classes.changing);
          nextSlide.style.removeProperty('display');
          if (nextSlide.querySelector('.has-video')) {
            var pauseButton = nextSlide.querySelector('.button--pause');
            if (!nextSlide.classList.contains(classes.processed)) {
              Drupal.behaviors.dart_utils.loadHeroVideo(nextSlide);
              nextSlide.classList.add(classes.processed);
            } else {
              pauseButton.click();
            }
          }
          if (activeSlide.querySelector('.has-video')) {
            var _pauseButton = activeSlide.querySelector('.button--pause');
            _pauseButton.click();
          }
        }, 1000);

        // We set our "Next" slide based on the parent direction class of the carousel.
        if (carousel.classList.contains(classes.right) && !fromPager) {
          setTimeout(function () {
            slideOrder('right');
          }, 1000);
        }
        if (carousel.classList.contains(classes.left) && !fromPager) {
          setTimeout(function () {
            slideOrder('left');
          }, 1000);
        }
      };
      var handleClick = function handleClick() {
        carousel.addEventListener('click', function (e) {
          // @TODO – Accommodate multiple pause buttons.
          var pauseButton = carousel.querySelector('.button--pause');
          // Since the event listener for the slide transition is on the whole carousel
          // we need to look for the pause button and not trigger then.
          if (!carousel.classList.contains(classes.changing) && e.target !== pauseButton) {
            carousel.classList.add(classes.changing);
            Drupal.behaviors.dart_utils.resetProgressBar(progressTimeline);
            clearInterval(slideTransitionInterval);
            slideTransitionInterval = setInterval(function () {
              slideTransition('right');
            }, 10000);
            if (window.innerWidth / 2 > e.clientX) {
              slideTransition('left');
            }
            if (window.innerWidth / 2 <= e.clientX) {
              slideTransition('right');
            }
          }
        });
      };

      /* Handle the hero cursor behavior. */
      var heroCursor = function heroCursor() {
        TweenMax.set(cursor, {
          xPercent: -50,
          yPercent: -50
        });

        // Fade the cursor in when it enters and run the positioning function.
        carousel.addEventListener('pointerenter', function (e) {
          TweenMax.to(cursor, 0.3, {
            opacity: 1
          });
          positionCircle(e);
        });

        // Fade the cursor out when it enters and run the positioning function.
        carousel.addEventListener('pointerleave', function (e) {
          TweenMax.to(cursor, 0.3, {
            opacity: 1
          });
          positionCircle(e);
        });

        // Run the positioning function when we're inside of the carousel.
        carousel.addEventListener('pointermove', function (e) {
          positionCircle(e);

          // If we're hovering over an element where the cursor should change,
          // the cursor shrinks and the arrow fades out.
          if (e.target.classList.contains('cursor--override') && !cursor.classList.contains(classes.hovering)) {
            cursor.classList.add(classes.hovering);
          }

          // If we put this in the else above we just get a flicker,
          // so we need to be explicit.
          if (!e.target.classList.contains('cursor--override') && cursor.classList.contains(classes.hovering)) {
            cursor.classList.remove(classes.hovering);
          }
        });
      };

      /**
       * Position the cursor in the carousel.
       * @param {string} direction The direction the cursor is pointing.
       */
      var positionCircle = function positionCircle(e) {
        var position = carousel.getBoundingClientRect().width / 2;
        var relX = e.pageX - carousel.offsetLeft;
        var relY = e.pageY - carousel.offsetTop;
        TweenMax.to(cursor, 0.3, {
          x: relX,
          y: relY
        });
        if (!carousel.classList.contains(classes.changing) && relX >= position) {
          carousel.classList.add('cursor-is-right');
          carousel.classList.remove('cursor-is-left');
        }
        if (!carousel.classList.contains(classes.changing) && relX <= position) {
          carousel.classList.add('cursor-is-left');
          carousel.classList.remove('cursor-is-right');
        }
      };

      // @TODO – add keyboard interaction.

      var handleSwipe = function handleSwipe() {
        var hammer = new Hammer(carousel);
        hammer.on('swipeleft', function () {
          slideOrder('right');
          slideTransition('right');
        });
        hammer.on('swiperight', function () {
          slideOrder('left');
          slideTransition('left');
        });
      };
      var slideTransitionInterval = setInterval(function () {
        slideTransition('right');
      }, 10000);

      // The cursor should only be active outside of LB.
      if (document.body.classList.contains(classes.lb)) {
        heroCursor();
      }
      slideOrder('right');
      handleClick();
      handleSwipe();
      Drupal.behaviors.dart_utils.loadProgressBar(progressBar, progressTimeline);
    }
  };
})(Drupal);